module.exports = (Promise.resolve(__parcel__require__("./" + "module.98d21018.da9e32ab.js"))).then(() => parcelRequire('9o1It'));